const client = require('contentful').createClient({
  space: 'l7uvwh6ev0bk',
  accessToken: 'xyngzij2WHzvNkP9N66nTnbwTuOP5Wz4Dw8f1zbxBjo',
});

const getBlogPosts = () =>
  client.getEntries().then((response) => {
    return response.items;
  });

export { getBlogPosts };
